import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { PicPayload, PicResponse } from "@/types/interface/pic";
import { handleResponse, handleResponseError } from "@/utils/api";

export const usePicStore = defineStore("picStore", () => {
  const pic = ref<PicResponse>();
  const pics = ref<PicResponse[]>([]);

  function initPics(data: any) {
    pics.value = data?.data;
  }

  function addNewPic(data: any) {
    pic.value = data;
  }

  async function dispatchGetPics(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.pic.getPic(page, limit, queryParam);
      if (status === 200 ) {
        initPics(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idPic = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.pic.findPic(idPic);
      if (status === 200 ) {
        addNewPic(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: PicPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.pic.createPic(payload);
      if (status === 200 ) {
        addNewPic(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idPic = "", payload: PicPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.pic.updatePic(idPic, payload);
      if (status === 200 ) {
        addNewPic(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idPic = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.pic.deletePic(idPic);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    pic,
    pics,
    initPics,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetPics,
    dispatchDelete
  };
});